import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {makeGetRequestToUrl} from './commonFunc.jsx';
import config from '../config/config.js';

const useChunkedRideData = (params) => {
  const [data, setData] = useState([]);  // Holds the cumulative data
  const [loading, setLoading] = useState(false);  // Loading state
  const [error, setError] = useState(null);  // Error state
  const [hasMore, setHasMore] = useState(true);  // To track if more data is available
  const [chunkedNoDriversFound, setChunkedNoDriversFound] = useState(false);
  const [chunkedAutoAssigned, setChunkedAutoAssigned] = useState(false);
  const [requestId, setRequestId] = useState(0);
  const [engagementData, setEngagementData] = useState([]);

  const serverUrl = config.serverUrl;
  const autosUrl = config.autosUrl;

  const navigate = useNavigate();

  const getEngagementDetails = async () => {
    try {
        const token = localStorage.getItem('token');
        const timestamp = new Date().getTime();

        const url = `${autosUrl}/admin/get_engagement_details`;
        const obj={
            token: token, is_panel_request: Number(1), request_id: Number(requestId)
        }
        const response =  await makeGetRequestToUrl(url, obj);
        if(response.flag==200){
          setEngagementData(response.data.engagement_details[0]);
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};

  useEffect(()=> {
    if(requestId!=0)
    getEngagementDetails();
  }, [requestId]);

  useEffect(() => {
    // Don't fetch data if already loading or no more data to fetch
    if (!hasMore || loading) return;

    const fetchData = async () => {
      setLoading(true);  // Set loading true before request

      try {
        const response = await axios.post(`${autosUrl}/customer/request_ride`, params);
        const responseString = response.data

        let responses = responseString.split('}{').map((item, index, array) => {
          if (index === 0) return JSON.parse(item + '}');
          if (index === array.length - 1) return JSON.parse('{' + item);
          return JSON.parse('{' + item + '}');
        });

        for(var i=0;i<responses.length;i++){
          if(responses[i].flag==600){
              console.log('falg 600 is recieved');
              setChunkedNoDriversFound(true);
              setLoading(false);
          }
          if(responses[i].flag==601){
              console.log('falg 601 is recieved');
              setChunkedAutoAssigned(true);
              setLoading(false);
              // console.log('request id=', responses[i].data.request_id);
              setRequestId(responses[i].data.request_id);
              // getEngagementDetails();
          }
        }
      } catch (err) {
        setError(err.message || "Error fetching data");
      } finally {
        setLoading(false);  // Reset loading state
      }
    };

    fetchData();
  }, []); 

  return { chunkedNoDriversFound, loading, chunkedAutoAssigned, engagementData };
};

export default useChunkedRideData;